// Copyright (c) 2020 Deere & Company

import './index.scss';

import * as busyCounter from '../../shared/action-creator/busy-counter';
import React, { Component } from 'react';
import { createErrorMessage, createSuccessMessage } from '../../shared/action-creator/alert-messages';
import {
    getForecastChanges, getForecastChangesConstraintKey, getForecastChangesConstraintType
} from './repositories';
import BusyCounterLoadingIndicator from '../../shared/components/busyCounter/busy-counter-loading-indicator';
import ForecastChangeTable from './components/forecast-change-table';
import LabeledReactSelect from '../../shared/components/options-drop-down/labeled-react-select';
import OptionsDropDown from '../../shared/components/options-drop-down';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { showLoadingIndicator } from '../../shared/state/busy-counter';
import { withRouter } from 'react-router-dom';

class ForecastChange extends Component {

    state = {
        types: [],
        keys: [],
        selectedKey: '',
        selectedType: '',
        results: []
    };

    componentDidMount = () => {

        this.props.increaseCounter();
        getForecastChangesConstraintType().then( response => {

            this.setState( {
                types: response
            } );
            this.props.decreaseCounter();

        } ).catch( () => {

            this.props.decreaseCounter();

        } );

    }

    handleTypeChange ( val ) {

        this.setState( {
            selectedType: val
        } );
        this.props.increaseCounter();
        getForecastChangesConstraintKey( val ).then( response => {

            const keys = response.map( item => ( {
                label: item.id.trim(),
                value: item.value.trim()
            } ) );
            this.setState( {
                keys,
                selectedKey: '',
                results: []
            } );
            this.props.decreaseCounter();

        } ).catch( () => {

            this.props.decreaseCounter();

        } );

    }

    handleKeyChange ( val ) {

        this.setState( {
            selectedKey: val.label,
            selectedKeyObj: val
        }, () => {

            this.refresh();

        } );

    }

    refresh () {

        this.props.increaseCounter();
        getForecastChanges( this.state.selectedType, this.state.selectedKey )
            .then( response => {

                this.setState( {
                    results: response
                } );
                this.props.decreaseCounter();

            } ).catch( () => {

                this.props.decreaseCounter();

            } );

    }

    render () {

        const {
            selectedKey, selectedKeyObj, selectedType, types, keys, results
        } = this.state;

        return (
            <section className="main-content">
                <BusyCounterLoadingIndicator busyCounter={this.props.busyCounter} />
                <header>
                    <h2 className="page-header">Forecast Changes</h2>
                </header>

                <main>
                    <section className="section-container">
                        <div className="atp-top-options atp-forecast-change-top-options">
                            <div className="select-options">
                                <OptionsDropDown
                                    className="atp-forecast-change-select"
                                    label="Type"
                                    isPlaceholderTranslated={true}
                                    onChange={this.handleTypeChange.bind( this )}
                                    optionDisplayAttributes={['value']}
                                    optionKey="id"
                                    options={types}
                                    placeholder="Select Type"
                                    selectedValue={selectedType}
                                />
                                {selectedType && (
                                    <LabeledReactSelect
                                        className="atp-forecast-change-select"
                                        label="Key"
                                        isPlaceholderTranslated={true}
                                        onChange={this.handleKeyChange.bind( this )}
                                        options={keys}
                                        placeholder="Select Key"
                                        selectedValue={selectedKeyObj}
                                    />
                                )}
                                {selectedType && selectedKey && <span onClick={this.refresh.bind( this )}><i className="icon fa fa-refresh" /></span>}

                            </div>
                        </div>
                        {selectedType && selectedKey && (
                            <ForecastChangeTable
                                results={results}
                            />
                        )}
                    </section>
                </main>
            </section>
        );

    }

}

const mapStateToProps = state => ( {
    busyCounter: showLoadingIndicator( state.application.busyCounter ),
    unit: state.application.unit,
    accessToken: state.oktaState.oktaState.accessToken
} );

ForecastChange.displayName = 'ForecastChange';
ForecastChange.propTypes = {
    busyCounter: PropTypes.bool.isRequired,
    increaseCounter: PropTypes.func.isRequired,
    decreaseCounter: PropTypes.func.isRequired,
    unit: PropTypes.object,
    location: PropTypes.object
};
const mapDispatchToProps = dispatch => ( {
    increaseCounter: () => dispatch( busyCounter.increaseBusyCounter() ),
    decreaseCounter: () => dispatch( busyCounter.decreaseBusyCounter() ),
    createSuccessMessage: message => dispatch( createSuccessMessage( message ) ),
    createErrorMessage: message => dispatch( createErrorMessage( message ) )
} );
export default connect(
    mapStateToProps, mapDispatchToProps
)( withRouter( ForecastChange ) );
